const config = {
  baseUrl: '/',
  //API_URL: 'http://localhost:8000/api',
  // API_URL: 'http://localhost:8000/cp/api',
  API_URL: 'https://utxapp.espsofttech.org/cp/api',
};

export default config;
